/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {TOKENS} from '../../components/design-system'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) root.style.height = '100%'
    return () => { if (root) root.style.height = 'auto' }
  }, [])

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      background: TOKENS.color.surface,
    }}>
      {/* Hero column (image + tagline) */}
      <div style={{
        flex: 1,
        minWidth: 0,
        backgroundImage: `linear-gradient(135deg, rgba(37,99,235,0.85), rgba(17,24,39,0.75)), url(${toAbsoluteUrl('/media/misc/login_bg.webp')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
        color: '#fff',
      }}
        className='d-none d-lg-flex'
      >
        <div style={{ maxWidth: 460 }}>
          <div style={{
            fontSize: TOKENS.typography.label.size,
            fontWeight: TOKENS.typography.label.weight,
            textTransform: TOKENS.typography.label.transform,
            letterSpacing: TOKENS.typography.label.tracking,
            opacity: 0.85,
            marginBottom: TOKENS.spacing.md,
          }}>
            CMB
          </div>
          <h1 style={{
            fontSize: 32,
            fontWeight: 700,
            lineHeight: 1.25,
            margin: 0,
            letterSpacing: -0.5,
          }}>
            Soluções em Sistemas de Energia Elétrica
          </h1>
          <p style={{
            marginTop: TOKENS.spacing.md,
            fontSize: 14,
            lineHeight: 1.6,
            opacity: 0.85,
          }}>
            Monitoramento em tempo real, gerenciamento remoto e histórico
            completo das suas caixas de medição.
          </p>
        </div>
      </div>

      {/* Form column */}
      <div style={{
        width: '100%',
        maxWidth: 540,
        background: TOKENS.color.card,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '40px',
      }}>
        <Link to='/' style={{ display: 'inline-flex', justifyContent: 'center', marginBottom: TOKENS.spacing.xl }}>
          <img
            alt='Logo CMB'
            src={toAbsoluteUrl('/media/logos/logo-cmb-v3.png')}
            style={{ height: 80, objectFit: 'contain' }}
          />
        </Link>

        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: '100%', maxWidth: 380 }}>
            <Outlet />
          </div>
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: TOKENS.spacing.lg,
          fontSize: 12,
          color: TOKENS.color.muted,
          marginTop: TOKENS.spacing.xl,
        }}>
          <a href='/privacy_policy_cmb_v1.html' target='_blank' style={{ color: 'inherit', textDecoration: 'none' }}>
            Termos de uso
          </a>
          <a href='#' target='_blank' style={{ color: TOKENS.color.action, textDecoration: 'none', fontWeight: 600 }}>
            Planos
          </a>
          <a href='#' target='_blank' style={{ color: 'inherit', textDecoration: 'none' }}>
            Contato
          </a>
        </div>
      </div>
    </div>
  )
}

export {AuthLayout}
